import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {ViewColor,UpdateColor} from "../../../redux/services/ColorServices/color.Services";
import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../../redux/services/subCategoriesService/subCategories.Services";
import {
  successToast,
  errorToast,
} from "../../../Utils/toast";

import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";


function EditColor({ data, onSuccess }) {
  const dispatch = useDispatch();
const [categories, setCategories] = useState([]);
const [subCategories, setSubCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
const [formData, setFormData] = useState({
  color_name: "",
  color_code: "",
  color_hex: "#000000",
  category_id: "",
  sub_category_id: "",
  description: "",
  status: 1,
});
const loadCategories = async () => {
  try {
    const res = await ActiveCategoryList();
    setCategories(res?.data || []);
  } catch (error) {
    console.log(error);
  }
};
const loadSubCategories = async (categoryId) => {
  try {
    const res = await ActiveSubCategoryList(categoryId);

    setSubCategories(res?.data?.data || []);
  } catch (error) {
    console.log(error);
    setSubCategories([]);
  }
};
useEffect(() => {
  loadCategories();

  if (data) {
    setFormData({
      color_name: data.color_name || "",
      color_code: data.color_code || "",
      color_hex: data.color_hex || "#000000",
      category_id: data.category_id || "",
      sub_category_id: data.sub_category_id || "",
      description: data.description || "",
      status: Number(data.status),
    });

    if (data.category_id) {
      loadSubCategories(data.category_id);
    }
  }
}, [data]);
const handleCategoryChange = async (e) => {
  const categoryId = e.target.value;

  setFormData((prev) => ({
    ...prev,
    category_id: categoryId,
    sub_category_id: "",
  }));

  await loadSubCategories(categoryId);
};

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (errors[name]) {
    setErrors((prev) => ({
      ...prev,
      [name]: null,
    }));
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
  const payload = {
  id: data.id,
  color_name: formData.color_name,
  color_code: formData.color_code,
  color_hex: formData.color_hex,
  category_id: Number(formData.category_id),
  sub_category_id: Number(formData.sub_category_id),
  description: formData.description,
  status: Number(formData.status),
};

      const res = await UpdateColor(payload);
    if (res?.data?.success) {
      successToast(res.data.message);

      dispatch(refreshProductList());
      dispatch(closeProductModal());
    }
  
    } catch (err) {
      console.log(err);

      errorToast(
        err?.message ||
        "Error updating role"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">

      <form onSubmit={handleSubmit} className="row g-3">

  {/* Color Name */}
  <div className="col-md-6">
    <label>
      Color Name <span className="text-danger">*</span>
    </label>
    <input
      type="text"
      name="color_name"
      value={formData.color_name}
      onChange={handleChange}
      className={`form-control custumform ${
        errors?.color_name ? "is-invalid" : ""
      }`}
      placeholder="Enter color name"
    />
  </div>

  {/* Color Code */}
  <div className="col-md-6">
    <label>
      Color Code <span className="text-danger">*</span>
    </label>
    <input
      type="text"
      name="color_code"
      value={formData.color_code}
      onChange={handleChange}
      className={`form-control custumform ${
        errors?.color_code ? "is-invalid" : ""
      }`}
      placeholder="Enter color code"
    />
  </div>

  {/* Category */}
  <div className="col-md-6">
    <label>
      Category <span className="text-danger">*</span>
    </label>

    <select
      name="category_id"
      value={formData.category_id}
      onChange={handleCategoryChange}
      className={`form-control custumform ${
        errors?.category_id ? "is-invalid" : ""
      }`}
    >
      <option value="">Select Category</option>

      {categories.map((item) => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  </div>

  {/* Sub Category */}
  <div className="col-md-6">
    <label>
      Sub Category <span className="text-danger">*</span>
    </label>

    <select
      name="sub_category_id"
      value={formData.sub_category_id}
      onChange={handleChange}
      className={`form-control custumform ${
        errors?.sub_category_id ? "is-invalid" : ""
      }`}
    >
      <option value="">Select Sub Category</option>

      {subCategories.map((item) => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  </div>

  {/* Color Hex */}
  <div className="col-md-6">
    <label>Color Hex</label>

    <div className="d-flex align-items-center gap-2">
      <input
        type="color"
        name="color_hex"
        value={formData.color_hex}
        onChange={handleChange}
        className="form-control form-control-color"
        style={{ width: "70px", height: "42px" }}
      />

      <input
        type="text"
        value={formData.color_hex}
        readOnly
        className="form-control custumform"
      />
    </div>
  </div>

  {/* Status */}
  <div className="col-md-6">
    <label>Status</label>

    <select
      name="status"
      value={formData.status}
      onChange={handleChange}
      className="form-control custumform"
    >
      <option value={1}>Active</option>
      <option value={0}>Inactive</option>
    </select>
  </div>

  {/* Description */}
  <div className="col-md-12">
    <label>Description</label>

    <textarea
      rows="3"
      name="description"
      value={formData.description}
      onChange={handleChange}
      className="form-control custumform"
      placeholder="Enter description"
    />
  </div>

  {/* Submit */}
  <div className="col-12 text-end">
    <button
      type="submit"
      className="add-btn"
disabled={isLoading}
    >
{isLoading ? "Updating..." : "Update Color"}
    </button>
  </div>

</form>

    </div>
  );
}

export default EditColor;